
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 460 460"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M425.934 0H171.662c-18.122 0-32.864 14.743-32.864 32.864v77.134h30V32.864A2.868 2.868 0 01171.662 30h254.272a2.868 2.868 0 012.864 2.864v254.272a2.868 2.868 0 01-2.864 2.865h-74.729v30h74.729c18.121 0 32.864-14.743 32.864-32.865V32.864C458.797 14.743 444.055 0 425.934 0z"}}),_c('path',{attrs:{"d":"M288.339 139.998H34.068c-18.122 0-32.865 14.743-32.865 32.865v254.272C1.204 445.257 15.946 460 34.068 460H288.34c18.122 0 32.865-14.743 32.865-32.864V172.863c.001-18.122-14.744-32.865-32.866-32.865zM288.341 430H34.068a2.868 2.868 0 01-2.865-2.864V172.863a2.868 2.868 0 012.865-2.865H288.34a2.868 2.868 0 012.865 2.865v254.273h.001a2.868 2.868 0 01-2.865 2.864z"}})])
          )
        }
      }
    